import { media } from '@displate/styleguide';

interface ScreenSizes {
  size376: number;
  size576: number;
  size768: number;
  size1024: number;
  size1280: number;
  size1440: number;
  size1920: number;
  size2560: number;
}

export const customScreenSizes: ScreenSizes = {
  size376: 376,
  size576: 576,
  size768: 768,
  size1024: 1024,
  size1280: 1280,
  size1440: 1440,
  size1920: 1920,
  size2560: 2560,
};

export const customMediaQueries = {
  width376: media.custom(customScreenSizes.size376),
  width576: media.custom(customScreenSizes.size576),
  width768: media.custom(customScreenSizes.size768),
  width1024: media.custom(customScreenSizes.size1024),
  width1280: media.custom(customScreenSizes.size1280),
  width1440: media.custom(customScreenSizes.size1440),
  width1920: media.custom(customScreenSizes.size1920),
  width2560: media.custom(customScreenSizes.size2560),
};
